export default __webpack_public_path__ + "static/media/fundo.203b8473.svg";